import React from "react";
import { MessageCircle } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { buildWhatsAppUrl, openWhatsApp } from "../lib/whatsapp";

const DEFAULT_MSG = "Merhaba, Aktav Yarka hakkında bilgi almak istiyorum.";

const WhatsAppFloat = () => {
  const { content } = useContent();
  const phone = content.company?.whatsapp || "";
  const handleClick = (e) => {
    e.preventDefault();
    openWhatsApp(phone, DEFAULT_MSG);
  };
  return (
    <a
      href={buildWhatsAppUrl(phone, DEFAULT_MSG)}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-40" />
      <span className="relative flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white pl-4 pr-5 py-3.5 rounded-full shadow-2xl transition-colors">
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
      </span>
    </a>
  );
};

export default WhatsAppFloat;
